import React from 'react'
import { NewStyledDealerLocationText, StyledDealerLocationTown } from './vehicle-location.style'
import { IconMapPin } from '@at/design-system-icons'

export const VehicleLocation = ({ vehicleLocation }: { vehicleLocation?: string | null }) => {
    if (vehicleLocation) {
        return (
            <NewStyledDealerLocationText as="span" data-testid="search-listing-location">
                <IconMapPin title="Dealer location" customSize={{ width: 16, height: 16 }} />
                <StyledDealerLocationTown>{vehicleLocation}</StyledDealerLocationTown>
            </NewStyledDealerLocationText>
        )
    }
    return null
}
